import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=4b8f94c6&lang=pug&"
import script from "./Topic.vue?vue&type=script&lang=js&"
export * from "./Topic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8f94c6')) {
      api.createRecord('4b8f94c6', component.options)
    } else {
      api.reload('4b8f94c6', component.options)
    }
    module.hot.accept("./Topic.vue?vue&type=template&id=4b8f94c6&lang=pug&", function () {
      api.rerender('4b8f94c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/blocs/Topic.vue"
export default component.exports